<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { manufacturerInformation } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="manufacturerInformation.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ manufacturerInformation.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td>
              <table class="w-full border-collapse">
                <tbody>
                  <tr>
                    <td class="w-1/2 align-top">
                      <span
                        v-if="manufacturerInformation.data.name"
                        class="block"
                      >
                        {{ manufacturerInformation.data.name }}
                      </span>

                      <span
                        v-if="manufacturerInformation.data.street"
                        class="block"
                      >
                        {{ manufacturerInformation.data.street }}
                      </span>

                      <span
                        v-if="
                          manufacturerInformation.data.city
                            || manufacturerInformation.data.zipCode
                        "
                        class="block"
                      >
                        {{
                          manufacturerInformation.data.zipCode
                            ? `${manufacturerInformation.data.zipCode} `
                            : ''
                        }}
                        {{ manufacturerInformation.data.city || '' }}
                      </span>

                      <span
                        v-if="manufacturerInformation.data.country"
                        class="block"
                      >
                        {{ manufacturerInformation.data.country }}
                      </span>
                    </td>

                    <td class="w-1/2 align-top">
                      <span
                        v-if="manufacturerInformation.data.website"
                        class="block"
                      >
                        <a
                          class="underline"
                          :href="manufacturerInformation.data.website"
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                        >
                          {{
                            $t('car-details.manufacturer-information-website')
                          }}
                        </a>
                      </span>

                      <span
                        v-if="manufacturerInformation.data.email"
                        class="block"
                      >
                        <a
                          class="underline"
                          :href="`mailto:${manufacturerInformation.data.email}`"
                        >
                          {{ manufacturerInformation.data.email }}
                        </a>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
